<div class="counter-container">
  <button class="decrement" (click)="minusOne()">
    <i class="fas fa-minus"></i>
  </button>
  <input type="number" [min]="min" [max]="max" [(ngModel)]="counter" />
  <button class="increment" (click)="addOne()">
    <i class="fas fa-plus"></i>
  </button>
</div>
